/**
 * Login Page Component
 * 
 * This component handles user authentication with
 * username and password input forms.
 */

import React, { useState } from 'react';
import { useApp } from '../context/AppContext';
import { useTranslations } from '../context/TranslationsContext';
import { authAPI } from '../api';

const LoginPage = () => {
  const { actions } = useApp();
  const { translations } = useTranslations();
  const { state } = useApp();
  const t = translations[state.currentLanguage];

  const [loginForm, setLoginForm] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const response = await authAPI.login(loginForm.username, loginForm.password);
      localStorage.setItem('token', response.access_token);
      
      // Set token in state immediately to trigger data fetching
      actions.setToken(response.access_token);
      actions.setAuth(true);
      actions.setActiveTab('dashboard');
      
      // Get user info
      const user = await authAPI.getCurrentUser(response.access_token);
      actions.setUser(user);
    } catch (error) {
      console.error('Login error:', error);
      alert('Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`app ${state.currentLanguage === 'ar' ? 'rtl' : 'ltr'}`}>
      <div className="login-container">
        <div className="login-card">
          <h1 className="login-title">{t.title}</h1>
          <form onSubmit={handleLogin} className="login-form">
            <div className="form-group">
              <label>{t.username}</label>
              <input
                type="text"
                value={loginForm.username}
                onChange={(e) => setLoginForm({...loginForm, username: e.target.value})}
                className="form-input"
                required
              />
            </div>
            <div className="form-group">
              <label>{t.password}</label>
              <input
                type="password"
                value={loginForm.password}
                onChange={(e) => setLoginForm({...loginForm, password: e.target.value})}
                className="form-input"
                required
              />
            </div>
            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? 'Loading...' : t.login}
            </button>
          </form>
          <div className="language-switch">
            <button
              onClick={() => actions.setLanguage(state.currentLanguage === 'ar' ? 'en' : 'ar')}
              className="language-toggle"
            >
              {state.currentLanguage === 'ar' ? 'EN' : 'AR'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
